export default __webpack_public_path__ + "media/images/icons/app-1-ffe8f1bfc4d119b0112f2b35ca012848.png";